module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M16 4.158V2h1a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2h1v2.158C5.218 5.13 0 10.95 0 18c0 7.732 6.268 14 14 14s14-6.268 14-14c0-7.05-5.218-12.87-12-13.842zM18 22h-6c-1.106 0-2-.894-2-2v-6c0-1.106.894-2 2-2s2 .894 2 2v4h4c1.106 0 2 .894 2 2s-.894 2-2 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/stopwatch-1.js
// module id = 1435
// module chunks = 14